import React, { useEffect, useState } from 'react';

import { Wrench, Package, FileCheck } from 'lucide-react';
import { getArcWeldingFormOptions } from '../../hooks/useArcWeldingFormOptions';
import CalibrationMainPage from '../../components/Calibration/CalibrationMainPage';
import MaterialsMainPage from '../../components/Materials/MaterialsMainPage';
import ArcWeldingHubPage from '../../components/ArcWelding/ArcWeldingHubPage';
import '../technical/HeatProfilePage.css';
import './CalibrationPage.css';

const TAB_ITEMS = [
    { id: 'calibration', label: 'Calibration', icon: <Wrench size={18} /> },
    { id: 'materials', label: 'Materials', icon: <Package size={18} /> },
    { id: 'aw-certificates', label: 'Arc Welding Certificates', icon: <FileCheck size={18} /> },
];

const Tabs = ({ items, activeTabId, onTabClick }) => {
    return (
        <div className="calibration-tabs-container">
            <div className="calibration-tabs">
                {items.map((item) => (
                    <div
                        key={item.id}
                        className={`calibration-tab-item ${activeTabId === item.id ? 'active' : ''}`}
                        onClick={() => onTabClick(item.id)}
                    >
                        {item.icon}
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

const CalibrationPage = () => {
    const [activeTab, setActiveTab] = useState('calibration');

    useEffect(() => {
        if (activeTab === 'aw-certificates') {
            getArcWeldingFormOptions().catch(() => {});
        }
    }, [activeTab]);

    return (
        <div className="calibration-page">

            <Tabs
                items={TAB_ITEMS}
                activeTabId={activeTab}
                onTabClick={setActiveTab}
            />



            <div className="calibration-content-wrapper heat-profile-content-wrapper">
                {activeTab === 'calibration' && (
                    <CalibrationMainPage embeddedInModernLayout />
                )}
                {activeTab === 'materials' && (
                    <MaterialsMainPage embeddedInModernLayout />
                )}
                {activeTab === 'aw-certificates' && (
                    <ArcWeldingHubPage />
                )}
            </div>
        </div>
    );
};

export default CalibrationPage;
